import { unreadAiActions } from "../stores/notificationStore";
import { serverlessRoutes } from "./constants";
import { getWithJwt } from "./requests";
import { errorTracker } from "./errorTracker";

// Fetches the count of unrated AI actions for the current trainer and
// updates the unreadAiActions store. Called on boot from initiateUser and
// after the AI Log screen mounts. Silently swallows errors — a missing
// badge is acceptable; surfacing a toast for a count fetch is not.
export const fetchUnreadAiActions = async (): Promise<void> => {
  try {
    const res = await getWithJwt(
      `${serverlessRoutes.AI_ACTION}/unread-count`
    );
    const count = Number(res?.data?.count);
    // TEMP: visible while we're wiring up the blue bubbles. Remove once
    // the count is reliably populating.
    // eslint-disable-next-line no-console
    console.log("[ai_actions] unread count fetch", { res, count });
    if (Number.isFinite(count)) {
      unreadAiActions.set(count);
    }
  } catch (err) {
    // TEMP: surface so we can see 404s from a stale API process.
    // eslint-disable-next-line no-console
    console.warn("[ai_actions] unread count fetch failed", err);
    errorTracker.captureError(err as Error | string, "warning", {
      context: "ai_actions",
      action: "fetch_unread_count",
    });
  }
};
